module.exports = __webpack_public_path__ + "img/19.86522f70.png";